export const setLocalLanguage = (value) => {
  localStorage.setItem('language', value);
};

export const getLocalLanguage = () => {
  return localStorage.getItem('language') || 'en';
};
